export function emptyPageRobotsMeta({ isEmpty }) {
  if (!isEmpty) {
    return [];
  }
  return [{ hid: "robots", name: "robots", content: "noindex, follow" }];
}
